// Error type definitions for extracting messages from various API error formats
interface ApiError {
  response?: {
    data?: {
      customData?: {
        title?: string
      }
      message?: string
    }
  }
  data?: {
    customData?: {
      title?: string
    }
    message?: string
  }
  message?: string
}

/**
 * Extract error message from various error formats
 * Handles various API error response formats
 * Priority: customData.title > response.data.message > data.message > message > fallback
 */
export const extractErrorMessage = (error: unknown): string => {
  // Handle string errors
  if (typeof error === 'string') {
    return error
  }

  // Cast to ApiError type for easier access
  const err = error as ApiError

  // Check for custom error title first (highest priority) - Axios style
  const customTitle = err.response?.data?.customData?.title
  if (customTitle && customTitle.length > 0) {
    return customTitle
  }

  // Check for standard error message in response - Axios style
  const responseMessage = err.response?.data?.message
  if (responseMessage && responseMessage.length > 0) {
    return responseMessage
  }

  // Check for RTK Query style data.customData.title
  const dataCustomTitle = err.data?.customData?.title
  if (dataCustomTitle && dataCustomTitle.length > 0) {
    return dataCustomTitle
  }

  // Check for RTK Query style data.message
  const dataMessage = err.data?.message
  if (dataMessage && dataMessage.length > 0) {
    return dataMessage
  }

  // Check for direct error message
  const directMessage = err.message
  if (directMessage && directMessage.length > 0) {
    return directMessage
  }

  return 'An unexpected error occurred'
}
